export function afterNextTick(callback) {
    setTimeout(callback);
}
export function afterStackCleared(callback) {
    Promise.resolve().then(callback);
}
